/**
 * Cache constants
 */

const CacheNamespace = {
    CATEGORY: 'category'
};

export {CacheNamespace};
